import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Inbox } from 'lucide-react';
import api from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';

export const meta = {
  id: 'my_open_tickets',
  category: 'tickets',
  titleKey: 'dashboard.widgets.myOpenTickets',
  descriptionKey: 'dashboard.widgets.myOpenTicketsDesc',
  defaultSize: 'sm',
  icon: Inbox,
};

export default function MyOpenTicketsWidget() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();

  const { data: myTicketsData } = useQuery({
    queryKey: ['my-open-tickets'],
    queryFn: () => api.get('/tickets', { params: { assigned_to: user?.id, status: 'open', limit: 5 } }).then(r => r.data),
    refetchInterval: 30000,
  });

  const myTickets = myTicketsData?.tickets || [];

  return (
    <div className="card" style={{ padding: 0, overflow: 'hidden', height: '100%' }}>
      <div className="card-header" style={{ padding: '14px 20px', borderBottom: '1px solid var(--c-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="card-title">{t('dashboard.myOpenTickets', 'My Open Tickets')}</div>
        <button className="btn btn-ghost btn-sm" onClick={() => navigate('/my-tickets')}>
          {t('dashboard.viewAll', 'View all')} →
        </button>
      </div>
      {myTickets.length === 0 ? (
        <div style={{ padding: 24, textAlign: 'center', color: 'var(--c-text-muted)', fontSize: 13 }}>
          🎉 {t('dashboard.noOpenTicketsAssigned', 'No open tickets assigned to you')}
        </div>
      ) : (
        myTickets.map((ticket) => (
          <div
            key={ticket.id}
            style={{
              padding: '10px 16px',
              borderBottom: '1px solid var(--c-border-subtle)',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
            }}
            onClick={() => navigate(`/tickets/${ticket.id}`)}
            onMouseEnter={e => (e.currentTarget.style.background = 'var(--c-surface-2)')}
            onMouseLeave={e => (e.currentTarget.style.background = '')}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {ticket.subject}
              </span>
              <span className={`badge badge-${ticket.priority}`} style={{ flexShrink: 0 }}>
                {t(`tickets.priorities.${ticket.priority}`)}
              </span>
            </div>
            <div style={{ fontSize: 11, color: 'var(--c-text-muted)' }}>
              #{ticket.ticket_number} · {ticket.company_name || ticket.contact_name || ticket.contact_email}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
